var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C14.6024 1.66669 18.3334 5.39765 18.3334 10C18.3283 14.6003 14.6003 18.3283 10 18.3334ZM3.33335 10.1434C3.37278 13.8111 6.36761 16.758 10.0355 16.7384C13.7033 16.7185 16.6663 13.7396 16.6663 10.0717C16.6663 6.40378 13.7033 3.42483 10.0355 3.40502C6.36761 3.3854 3.37278 6.33232 3.33335 10V10.1434ZM10.8334 14.1667H9.16669V10.8334H5.83335V9.16669H9.16669V5.83335H10.8334V9.16669H14.1667V10.8334H10.8334V14.1667Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleOutline);
export default __webpack_public_path__ + "static/media/plus_circle_outline.e4aae6997176af1b7617dc1de25a6c86.svg";
export { ForwardRef as ReactComponent };